import type { ZodIssue, ZodType, ZodTypeDef } from "zod";

/**
 * Validate zod schema
 *
 * The schema's input type is left as `unknown`, so that `T` is inferred from
 * what the schema produces rather than from both ends of it. A schema built
 * from `.catch()` or `.transform()` accepts more than it returns, and tying `T`
 * to the input as well would widen it to the loosest of the two.
 *
 * @param schema - The zod schema to validate against
 * @param data - The data to validate
 * @returns [validatedData, errors] - The validated data and any errors
 */
export function validateSchema<T>(
  schema: ZodType<T, ZodTypeDef, unknown>,
  data: unknown,
): [T | null, ZodIssue[] | null] {
  const validatedData = schema.safeParse(data);
  if (validatedData.success) {
    return [validatedData.data, null];
  }
  return [null, validatedData.error.errors];
}
